import { axios } from '@Root/API'

export const getEthnicities = () => {
	return axios.get(`data-hesa-ethnicity-types`)
}
